import { useCallback, useMemo, useSyncExternalStore } from "react";

const queries = {
  desktop: "(max-width: 1280px)",
  largeDesktop: "(max-width: 1536px)",
  mobile: "(max-width: 768px)",
  mobileXs: "(max-width: 640px)",
  tablet: "(max-width: 1024px)",
};
type MediaQuery = keyof typeof queries;

export function useMediaQuery(queryKey: MediaQuery) {
  const query = queries[queryKey];
  const getSnapshot = useCallback(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia === "undefined"
    ) {
      return false;
    }
    return window.matchMedia(query).matches;
  }, [query]);

  const subscribe = useMemo(() => {
    const mediaQueryList = window.matchMedia(query);

    return (notify: () => void) => {
      mediaQueryList.addEventListener("change", notify);
      return () => {
        mediaQueryList.removeEventListener("change", notify);
      };
    };
  }, [query]);
  const match = useSyncExternalStore(subscribe, getSnapshot);

  return match;
}
